import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import EmployeeDetailsWrapper from "./EmployeeDetailsWrapper.style";
import AttributesList from "../../../components/layouts/AttributesList";
import { useIntl } from "react-intl";
import { Space, Tag } from "antd";
import { useParams } from "react-router-dom";

import { DEFAULT_INTL_CONFIG } from "react-intl/src/utils";

const EmployeeDetailsHeader = (props) => {
  const { staff } = props;
  let { branchId } = useParams();
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const intl = useIntl();

  const attributes = {};
  const {
    id,
    local_id_number,
    accounting_info,
    work_periods,
    created_at,
    updated_at,
    foreign,
  } = activeEmployee;
  if (id) {
    attributes["app.forms.employee.id"] = id;
  }
  if (foreign && foreign.passport_number) {
    attributes["app.forms.employee.foreign.passport_number"] =
      foreign.passport_number;
  } else if (local_id_number) {
    attributes["app.forms.employee.local_id_number"] = local_id_number;
  }
  if (accounting_info && accounting_info.number) {
    attributes["app.employees.accounting_info.number"] = accounting_info.number;
  }
  if (work_periods && work_periods.length > 0) {
    const lastPeriod = work_periods[work_periods.length - 1];
    if (lastPeriod) {
      const { start, end } = lastPeriod;
      if (end) {
        attributes["app.employees.employedUntil"] = moment(end).format("l");
      } else if (start) {
        const years =
          Math.round((moment().diff(start, "months") / 12) * 10) / 10;
        if (years > 1) {
          attributes[
            "app.employees.seniority"
          ] = `${years} ${intl.formatMessage({
            id: "app.employees.years",
          })}`;
        } else {
          const months = Math.round(moment().diff(start, "months"));
          attributes[
            "app.employees.seniority"
          ] = `${months} ${intl.formatMessage({
            id: "app.employees.months",
          })}`;
        }
      }
    }
  }

  if (created_at) {
    attributes["app.forms.employee.created_at"] =
      moment(created_at).format("l");
  }
  if (updated_at) {
    attributes["app.forms.employee.updated_at"] =
      moment(updated_at).format("l");
  }
  let branches = [];
  if (
    activeEmployee &&
    activeEmployee.branch_active &&
    activeEmployee.branch_active.length > 0
  ) {
    activeEmployee.branch_active.forEach((branch) => {
      const filtered = activeEmployee.active_branches.filter(
        (i) => i.id === branch.branch_id
      )[0];
      branches.push({ ...filtered, active: branch.active });
    });
  }

  return (
    <EmployeeDetailsWrapper>
      <div style={{ paddingTop: "16px" }}>
        <Space size={[0, 8]} wrap>
          {branches.map((r) => (
            <Tag
              key={r.id}
              style={{ opacity: r.active ? 1 : 0.4 }}
              color={r.id === +branchId ? "success" : ""}
            >
              {r.name}
            </Tag>
          ))}
        </Space>
      </div>
      <AttributesList attributes={attributes} />
    </EmployeeDetailsWrapper>
  );
};

export default EmployeeDetailsHeader;
